/* eslint-disable no-var, consistent-return */

var ReactDOM = require('react-dom');
var React = require('react');
var BlueBoxContent = require('../../react/PricePromise/BlueBoxContent').default;
var PricePromiseTab = require('../../react/PricePromise/PricePromiseTab').default;
var HoverCallout = require('../hover-callout/hover-callout.es6');
var utils = require('../../../utils');
var productPageTabs = require('../../productPageTabs.js');

const containsElement = utils.containsElement;

export default class BlueBoxWrapper {
  constructor(element, props) {
    props.expandPricePromiseTab = getExpandPricePromiseTabFn(props);

    const callout = new HoverCallout(
      getContentFunction(props),
      element,
      offsetsAndDimensions,
      HoverCallout.ALIGNMENT_BOTTOM,
      { className: 'price-promise-bluebox' }
    );

    this.show = () => {
      callout.show();
      document.addEventListener('keydown', this.hide);
      document.addEventListener('click', this.hide);
    };

    this.hide = (event) => {
      // Disregard the event if it is a keyboard key other than ESC
      if (event instanceof KeyboardEvent && event.keyCode !== 27) {
        return;
      }
      // Disregard the event if it is a click inside of the callout
      // The check for "event.target.parentElement === null" was added because the BlueBox
      // 'show more' button is removed after it is clicked on. (It is detached from DOM, so it has
      // no parentElement and fails the containsElement test)
      if (event instanceof MouseEvent && (containsElement(callout.getElement(), event.target) ||
        event.target.parentElement === null)) {
        return;
      }
      // Otherwise, hide the callout
      document.removeEventListener('keydown', this.hide);
      document.removeEventListener('click', this.hide);
      callout.destroy();
    };

    this.destroy = () => {
      this.element.removeEventListener('copy', this.show);
      this.hide();
    };

    // This modifies the props object that was passed to BlueBoxContent through getContentFunction,
    // making the hide function available from within BlueBoxContent.
    // It is made in an ugly way, because getContentFunction must be called before the HoverCallout
    // constructor, but the hide function needs to use the created HoverCallout instance - a
    // circular dependency.
    // (see callout, getContentFunction)
    props.hide = this.hide;

    element.addEventListener('copy', this.show);
  }

  static init(element, props) {
    if (!(element instanceof Element)) {
      console.error('[BlueBoxWrapper] element is not an element');
      return;
    }
    if (!props) {
      console.error('[BlueBoxWrapper] no price promise data specified');
      return;
    }
    if (window.App.Platform.isMobileViewPort()) {
      return;
    }
    return new BlueBoxWrapper(element, props);
  }
}

function getContentFunction(props) {
  return (element) => {
    ReactDOM.render(React.createElement(BlueBoxContent, props), element);
  };
}

function offsetsAndDimensions(element, target) {
  const targetHeight = target.getBoundingClientRect().height;

  return {
    top: targetHeight + 10, // See arrow-size in price-promise-bluebox.styl
    left: 0
  };
}

/**
 * Returns a function that re-renders PricePromiseTab in expanded state and scrolls it into view
 * @param props price promise data that will be passed to PricePromiseTab
 * @returns {function()}
 */
function getExpandPricePromiseTabFn(props) {
  return () => {
    const pricePromiseElement = document.querySelector('[data-component="price-promise-table"]');
    if (pricePromiseElement) {
      ReactDOM.render(
        React.createElement(PricePromiseTab, {
          productName: document.querySelector('h1.page-title').innerText,
          ...props,
          expanded: true
        }),
        pricePromiseElement
      );
    }
    productPageTabs.toggleTab('#tab5', 'price-promise-section');
  };
}
